module.exports = __webpack_public_path__ + "static/img/common-banner.2227d314.2227d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-banner.2227d314.png
// module id = /rrW
// module chunks = 0